export class LevelType {
    id:number
    name:string
    departmentDto:any
    schemeDto:any

}